var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"opened-state":"export","small":""}},[_c('Exporter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }